module.exports = __webpack_public_path__ + "static/img/lead_up.042b7e0e.png";